<template>
  <div style="position: relative">
    <FilterFields :fields="[
      {
        type: 'text',
        label: 'Nome',
        field: 'cliente',
      },
      {
        type: 'text',
        label: 'E-mail',
        field: 'email',
      },
      {
        type: 'text',
        label: 'CNPJ',
        field: 'cnpj',
      },
    ]" />
    <v-avatar v-if="nivelPartner && nivelPartner.nivel != 1" style="position: absolute; top: 0; left: 70px; margin-top: -20px">
      <img :src="nivelPartner.selo" />
    </v-avatar>
    <router-link v-if="nivelPartner && nivelPartner.nivel == 5" style="position: absolute; top: 0; left: 140px"
      class="btn btn-sm btn-primary btn-hover-primary btn-icon mr-2" v-b-tooltip="'Configuração White Label'" :to="{
        name: 'clientesConfiguracao',
      }">
      <Settings :size="16" title="Configuração" />
    </router-link>
    <button v-if="nivelPartner && nivelPartner.nivel == 5" style="position: absolute; top: 0; left: 190px"
      class="btn btn-sm btn-success btn-hover-success btn-icon mr-2" v-b-tooltip.right="'Baixar PDV Offline'"
      :disabled="baixandoPdvOffline" @click="baixarPdvOffline">
      <b-spinner small v-if="baixandoPdvOffline" />
      <Download v-else :size="16" title="Baixar PDV Offline" />
    </button>

    <div class="apps-wallet-row">
      <section class="apps-wallet-card apps-wallet-card-flex">
        <div class="apps-wallet-card-header">
          <span class="apps-wallet-kicker">Resumo da Revenda</span>
          <h4 class="apps-wallet-title">Gestão de saldo e clientes</h4>
        </div>

        <div class="apps-wallet-grid">
          <div class="apps-wallet-item">
            <span>Total de clientes</span>
            <strong>{{ totalClientesResumo }}</strong>
            <small>Licenças disponíveis: {{ licencasDisponiveis }}</small>
          </div>
          <div class="apps-wallet-item destaque-licencas">
            <span>Licenças</span>
            <strong
              >{{ licencasDisponiveis }} disponíveis /
              {{ licencasUtilizadas }} ativos</strong
            >
            <small>
              <template v-if="totalLicencas > 0">
                {{ percentualUsoLicencas }}% das licenças em uso
              </template>
              <template v-else>Nenhuma licença utilizada</template>
            </small>
          </div>
          <div class="apps-wallet-item destaque">
            <span>Saldo de Apps</span>
            <strong v-if="loadingSaldoApps">Carregando...</strong>
            <strong v-else-if="erroSaldoApps">Indisponível</strong>
            <strong v-else
              >{{ formatarMoedaLicenca(saldoApps.disponivel) }} disponível</strong
            >
          </div>
          <div class="apps-wallet-item">
            <span>Saldo usado</span>
            <strong v-if="loadingSaldoApps">Carregando...</strong>
            <strong v-else-if="erroSaldoApps">Indisponível</strong>
            <strong v-else
              >{{ formatarMoedaLicenca(saldoApps.usado) }} consumido</strong
            >
          </div>
          <div
            class="apps-wallet-item"
            v-if="!loadingSaldoApps && !erroSaldoApps && saldoApps.creditado > 0"
          >
            <span>Total creditado</span>
            <strong>{{ formatarMoedaLicenca(saldoApps.creditado) }}</strong>
          </div>
        </div>

        <div v-if="erroSaldoApps" class="apps-wallet-note text-muted">
          {{ erroSaldoApps }} Os totais de clientes e licenças continuam disponíveis.
        </div>

        <div class="apps-wallet-note text-muted">
          Licenças utilizadas são calculadas apenas pelos clientes que consomem
          licença.
        </div>

        <div class="apps-wallet-actions">
          <b-button variant="light-primary" :disabled="loadingSaldoApps || !!erroSaldoApps" @click="abrirModalExtratoApps">
          Ver extrato
        </b-button>
        </div>
      </section>

      <section
        v-if="totalClientesFree > 0 || loadingClientesFree"
        class="apps-wallet-card apps-wallet-card-compact clientes-free-mini-card"
        role="button"
        tabindex="0"
        @click="abrirModalClientesFree"
        @keyup.enter="abrirModalClientesFree"
      >
        <div class="apps-wallet-card-header">
          <span class="apps-wallet-kicker">Clientes Free</span>
          <h4 class="apps-wallet-title">Aguardando ativação</h4>
        </div>

        <div v-if="loadingClientesFree" class="text-muted">Carregando...</div>
        <div v-else class="apps-wallet-mini-count">
          <strong>{{ totalClientesFree }}</strong>
          <span>cliente(s) free</span>
        </div>

        <ul v-if="!loadingClientesFree && clientesFreeResumoMini.length" class="clientes-free-mini-list">
          <li v-for="clienteFree in clientesFreeResumoMini" :key="clienteFree.id_empresa">
            <span class="clientes-free-mini-nome">{{ clienteFree.cliente }}</span>
            <span :class="clienteFree.dias_restantes < 0 ? 'text-danger font-weight-bold' : 'text-muted'">
              {{ labelDiasRestantesFree(clienteFree) }}
            </span>
          </li>
        </ul>
        <div v-if="clientesFree.length > clientesFreeResumoMini.length" class="text-muted clientes-free-mini-mais">
          +{{ clientesFree.length - clientesFreeResumoMini.length }} outro(s)
        </div>

        <div class="apps-wallet-note text-muted">Clique para ver detalhes e ativar</div>
      </section>
    </div>

    <b-modal
      id="modal-clientes-free-revenda"
      title="Clientes free aguardando ativação"
      hide-footer
      centered
      size="xl"
    >
      <div v-if="loadingClientesFree" class="text-muted">Carregando clientes free...</div>
      <div v-else-if="!clientesFree.length" class="text-muted">Nenhum cliente free pendente de ativação.</div>
      <div v-else class="table-responsive">
        <table class="table table-sm apps-wallet-table">
          <thead>
            <tr>
              <th>Cliente</th>
              <th>CNPJ</th>
              <th>Cadastro</th>
              <th>Validade</th>
              <th>Dias restantes</th>
              <th>Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="clienteFree in clientesFree" :key="clienteFree.id_empresa">
              <td>
                {{ clienteFree.cliente }}
                <span class="text-muted d-block" style="font-size: 11px;">{{ clienteFree.email }}</span>
              </td>
              <td>{{ clienteFree.cnpj ? formatCpfCnpj(clienteFree.cnpj) : '' }}</td>
              <td>{{ formatDate(clienteFree.data_cadastro) }}</td>
              <td>{{ formatDate(clienteFree.data_validade) }}</td>
              <td>
                <span :class="clienteFree.dias_restantes < 0 ? 'text-danger font-weight-bold' : 'text-dark'">
                  {{ clienteFree.dias_restantes }}
                </span>
              </td>
              <td>
                <span v-if="clienteFree.bloqueado" class="label label-sm label-inline label-light-danger">Bloqueado</span>
                <span v-else-if="clienteFree.expirado" class="label label-sm label-inline label-light-warning">Expirado</span>
                <span v-else class="label label-sm label-inline label-light-success">Free</span>
              </td>
              <td class="text-right">
                <button class="btn btn-xs btn-success btn-hover-success" @click="ativarClienteFree(clienteFree)">
                  Ativar cliente
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-modal>

    <b-modal id="modal-extrato-apps-revenda" title="Extrato de saldo de Apps" hide-footer centered size="lg">
      <div v-if="loadingSaldoApps" class="text-muted">Carregando saldo de Apps...</div>
      <div v-else-if="!extratoSaldoApps.length" class="text-muted">Nenhuma movimentação encontrada.</div>
      <div v-else class="table-responsive">
        <table class="table table-sm apps-wallet-table">
          <thead>
            <tr>
              <th>Data</th>
              <th>Tipo</th>
              <th>Descrição</th>
              <th>Valor</th>
              <th>Saldo após</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="movimento in extratoSaldoApps" :key="movimento.id">
              <td>{{ formatarDataExtratoApps(movimento.created_at) }}</td>
              <td>{{ tipoMovimentoExtratoApps(movimento) }}</td>
              <td>{{ movimento.description || 'Sem descrição' }}</td>
              <td>
                <span class="apps-wallet-value" :class="classeValorExtratoApps(movimento)">
                  {{ sinalValorExtratoApps(movimento) }} {{ formatarMoedaLicenca(movimento.amount) }}
                </span>
              </td>
              <td>{{ formatarMoedaLicenca(movimento.balance_after) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-modal>

    <b-modal id="modal-uso-empresa-clientes"
      :title="empresaUsoSelecionada ? 'Análise de Uso — ' + empresaUsoSelecionada.cliente : 'Análise de Uso'"
      hide-footer centered size="lg">
      <div v-if="loadingUso" class="text-center py-5">
        <b-spinner variant="primary" label="Carregando..." />
        <p class="mt-3 text-muted">Carregando dados de uso...</p>
      </div>
      <div v-else-if="usoEmpresa">
        <div class="rounded p-4 mb-4 text-center"
          :style="{
            background: temperaturaUso.tipo === 'quente'
              ? 'linear-gradient(135deg, #ff6b35, #f7c59f)'
              : temperaturaUso.tipo === 'morno'
              ? 'linear-gradient(135deg, #f7b731, #ffe082)'
              : 'linear-gradient(135deg, #2980b9, #a8d8ea)',
            color: temperaturaUso.tipo === 'frio' ? '#fff' : '#333',
          }">
          <div style="font-size: 48px; line-height: 1;">
            {{ temperaturaUso.tipo === 'quente' ? '🔥' : temperaturaUso.tipo === 'morno' ? '🌤️' : '❄️' }}
          </div>
          <h4 class="mt-2 mb-1 font-weight-bold">
            {{ temperaturaUso.tipo === 'quente' ? 'Cliente Quente' : temperaturaUso.tipo === 'morno' ? 'Cliente Morno' : 'Cliente Frio' }}
          </h4>
          <p class="mb-3 font-weight-bold">
            <template v-if="temperaturaUso.dias === null">Sem atividade registrada</template>
            <template v-else-if="temperaturaUso.dias === 0">Ativo hoje!</template>
            <template v-else>Última atividade há {{ temperaturaUso.dias }} dia(s)</template>
          </p>
          <div class="px-5">
            <div class="progress" style="height: 14px; border-radius: 7px; background: rgba(255,255,255,0.35);">
              <div class="progress-bar bg-white"
                :style="{ width: temperaturaScore + '%' }"
                role="progressbar" />
            </div>
            <div class="d-flex justify-content-between mt-1" style="font-size: 11px;">
              <span>❄️ Inativo</span>
              <span>Score de Uso: {{ temperaturaScore }}%</span>
              <span>🔥 Muito Ativo</span>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 mb-3" v-for="(item, idx) in metricasUso" :key="idx">
            <div class="card border shadow-sm h-100">
              <div class="card-body p-3 d-flex align-items-center">
                <span style="font-size: 26px; min-width: 38px; text-align: center;">{{ item.icone }}</span>
                <div class="ml-3">
                  <div class="text-muted" style="font-size: 11px; text-transform: uppercase; letter-spacing: 0.5px;">{{ item.label }}</div>
                  <div v-if="item.valor">
                    <span class="font-weight-bold"
                      :class="item.dias <= 7 ? 'text-success' : item.dias <= 30 ? 'text-warning' : 'text-danger'">
                      {{ diasDesde(item.valor) }}
                    </span>
                    <div class="text-muted" style="font-size: 11px;">{{ formatUsoDt(item.valor) }}</div>
                  </div>
                  <div v-else class="text-muted font-weight-bold" style="font-size: 13px;">Nunca utilizado</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <TableApp titulo="Gestão de Clientes" subTitulo="Controle de forma simples todos seus clientes"
      api-url="empresa/meus-clientes" acaoBtn="/#/clientesNovo" textoBtn="Novo Cliente" :fields="fields"
      classFilterColumn="clientes" ref="clientes" :perPage="10" @loaded="onClientesLoaded">
      <template slot="customRow" slot-scope="props">
        <span slot="nome" v-if="props.field == 'nome'">
          <span class="pl-0 pt-8">
            <div class="d-flex align-items-center">
              <div class="symbol symbol-40 symbol-light-primary flex-shrink-0" style="margin-right: 10px"></div>
              <div>
                <a class="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg">{{ props.rowData.cliente
                  }}</a>
                <span class="text-muted font-weight-bold d-block">Fantasia: {{ props.rowData.nome_fantasia }}<br />
                  Telefone: {{ props.rowData.fone }}<br />
                  Email: {{ props.rowData.email }}<br />
                  Data cadastro:
                  {{ formatDate(props.rowData.data_cadastro) }} <br />
                </span>
                <span v-if="props.rowData.revenda"
                  class="label label-lg label-inline label-light-success">Revenda</span>
                <span v-else class="label label-lg label-inline label-light-primary">Cliente</span><br>
                <span class="text-dark-75" v-if="props.rowData.empresa.licenca_revenda">Licenças: {{
                  props.rowData.empresa.licenca_revenda.total }}
                </span>
              </div>
            </div>
          </span>
        </span>
        <span slot="cnpj" v-if="props.field == 'cnpj'">
          <span style="width: 110px">
            <div class="font-weight-bolder font-size-lg mb-0" v-if="props.rowData.cnpj">
              {{ formatCpfCnpj(props.rowData.cnpj) }}
            </div>
            <div v-else></div>
          </span>
        </span>
        <span slot="cliente_cidade" v-if="props.field == 'cliente_cidade'">
          <span style="width: 110px">
            <div class="font-weight-bolder font-size-lg mb-0">
              {{ props.rowData.cliente_cidade }}
              <span class="text-muted font-weight-bold d-block" v-if="props.rowData.cliente_uf">UF: {{
                props.rowData.cliente_uf }}
              </span>
            </div>
          </span>
        </span>
        <span slot="data_validade" v-if="props.field == 'data_validade'">
          <div class="license-summary-cell">
            <div class="license-plan-line">
              <span class="license-plan-badge">
                {{ siglaPlanoLicenca(props.rowData) }}
              </span>
              <strong>{{ nomePlanoLicenca(props.rowData) }}</strong>
            </div>
            <div class="license-muted" v-if="dataValidadeLicenca(props.rowData)">
              Vence: {{ dataValidadeLicenca(props.rowData) }}
            </div>

            <div class="license-lines" v-if="mostrarModulosPlugins">
              <div class="license-row">
                <span>Plano</span>
                <strong>
                  {{ formatarMoedaLicenca(valorAnualPlanoLicenca(props.rowData)) }}/ano
                </strong>
              </div>

              <template v-if="totalAppsAtivosLicenca(props.rowData) > 0">
                <div
                  class="license-row license-apps-row"
                  v-b-tooltip.hover.html="tooltipAppsLicenca(props.rowData)"
                >
                  <span>Módulos/plugins</span>
                  <strong>{{ totalAppsAtivosLicenca(props.rowData) }} ativos</strong>
                </div>
                <div
                  class="license-row license-muted"
                  v-if="totalAnualAppsLicenca(props.rowData) > 0"
                >
                  <span>Anual apps</span>
                  <span>
                    {{ formatarMoedaLicenca(totalAnualAppsLicenca(props.rowData)) }}/ano
                  </span>
                </div>
              </template>
              <div v-else class="license-empty">Sem módulos/plugins ativos</div>
            </div>

            <div class="license-total-line" v-if="mostrarModulosPlugins">
              <span>Total anual</span>
              <strong>
                {{ formatarMoedaLicenca(totalAnualLicenca(props.rowData)) }}/ano
              </strong>
            </div>

            <div class="license-status-line">
              <span v-if="props.rowData.bloqueado"
                class="label label-sm label-inline label-light-danger">Bloqueado</span>
              <span v-else class="label label-sm label-inline label-light-success">Ativo</span>
            </div>
          </div>
        </span>
        <span slot="actions" v-if="props.field == 'actions'">
          <div class="row-actions" style="text-align: right !important">
            <span style="overflow: visible; position: relative; width: 130px">
              <div class="dropdown dropdown-inline">
                <router-link v-show="props.rowData.revenda" class="btn btn-xs btn-info btn-hover-info btn-icon mr-1"
                  v-b-tooltip="'Lista de clientes'" :to="{
                    name: 'revendasListaClientes',
                    params: {
                      id_revenda: props.rowData.id_empresa,
                      rota: 'clientesLista'
                    },
                  }">
                  <ListaCliente :size="13" />
                </router-link>
                <router-link class="btn btn-xs btn-info btn-hover-info btn-icon mr-1" v-b-tooltip="'Contrato'" :to="{
                  name: 'clientesContratoEditar',
                  params: {
                    id_empresa: props.rowData.id_empresa,
                  },
                }">
                  <Contract :size="13" title="Contrato" />
                </router-link>
                <button
                  v-if="mostrarModulosPlugins"
                  @click="abrirModalAppsCliente(props.rowData)"
                  class="btn btn-xs btn-primary btn-hover-primary btn-icon mr-1"
                  v-b-tooltip="'Gerenciar módulos e plugins'"
                >
                  <AppsIcon :size="13" />
                </button>
                <button @click="liberarAcesso(props.rowData)"
                  class="btn btn-xs btn-success btn-hover-success btn-icon mr-1" v-b-tooltip="'Liberar Acesso'">
                  <Block :size="13" />
                </button>
                <button @click="bloquearAcesso(props.rowData)"
                  class="btn btn-xs btn-warning btn-hover-warning btn-icon mr-1" v-b-tooltip="'Bloquear Acesso'">
                  <Block :size="13" />
                </button>
                <button @click="reenviarEmail(props.rowData)" class="btn btn-xs btn-info btn-hover-info btn-icon mr-1"
                  v-b-tooltip="'Reenviar e-mail primeiro acesso'">
                  <SendEmail :size="13" />
                </button>
                <button v-if="props.rowData.revenda" @click="setarLicencas(props.rowData)"
                  class="btn btn-xs btn-warning btn-hover-warning btn-icon mr-1"
                  v-b-tooltip="'Informar Licenças para Revenda'">
                  <InserirLicenca :size="13" />
                </button>
                <button @click="verUsoEmpresa(props.rowData)"
                  class="btn btn-xs btn-secondary btn-hover-secondary btn-icon mr-1"
                  v-b-tooltip="'Análise de Uso'">
                  <Analytics :size="13" />
                </button>
              </div>
            </span>
          </div>
        </span>
      </template>
    </TableApp>

    <b-modal
      id="modal-apps-cliente-revenda"
      :title="clienteAppsSelecionado ? 'Apps do cliente — ' + clienteAppsSelecionado.cliente : 'Apps do cliente'"
      hide-footer
      centered
      size="xl"
      dialog-class="apps-modal-fullscreen-dialog"
      content-class="apps-modal-fullscreen-content"
    >
      <div class="apps-modal-shell">
        <div class="apps-modal-scroll">
        <div class="apps-modal-top-row mb-3">
          <div class="apps-modal-header">
            <p class="mb-1">
              Cliente: <strong>{{ clienteAppsSelecionado ? clienteAppsSelecionado.cliente : 'Não informado' }}</strong>
            </p>
            <p class="mb-1">
              CNPJ/CPF: <strong>{{ documentoClienteAppsSelecionado }}</strong>
            </p>
            <p class="mb-0">
              Saldo disponível da revenda: <strong>{{ formatarMoedaLicenca(saldoApps.disponivel) }}</strong>
            </p>
          </div>

          <div class="apps-toolbar-compact">
            <b-form-input
              v-model.trim="buscaFeatures"
              placeholder="Buscar módulo ou plugin..."
              size="sm"
              class="apps-toolbar-search-compact"
            />

            <div class="apps-toolbar-filters apps-toolbar-filters-compact mt-2">
              <button
                v-for="filtro in filtrosRapidosFeatures"
                :key="filtro.value"
                type="button"
                class="apps-filter-chip"
                :class="{ ativo: filtroRapidoFeatures === filtro.value }"
                @click="filtroRapidoFeatures = filtro.value"
              >
                {{ filtro.text }}
              </button>
            </div>
          </div>
        </div>

        <div class="alert alert-light-warning py-2 px-3 mb-3">
          A liberação será válida por 12 meses e consumirá o valor anual do saldo da revenda.
        </div>

        <div v-if="loadingFeaturesCliente" class="text-center py-5">
          <b-spinner variant="primary" label="Carregando..." />
          <p class="mt-3 text-muted">Carregando módulos e plugins...</p>
        </div>
        <div v-else>
          <div class="apps-license-pricing-box mb-3">
            <div>
              <span class="apps-field-label">Licença do cliente</span>
              <strong>{{ nomePlanoLicenca(clienteAppsSelecionado) }}</strong>
              <div class="text-muted small">
                Custo anual: {{ formatarMoedaLicenca(custoAnualLicencaSelecionada) }}
              </div>
            </div>
            <div>
              <label class="apps-field-label">
                Valor anual a cobrar (licença)
              </label>
              <b-input-group prepend="R$" size="sm">
                <b-form-input
                  v-model.number="vendaValorAnualLicenca"
                  type="number"
                  min="0"
                  step="0.01"
                />
              </b-input-group>
              <div class="text-muted small mt-1">
                {{ formatarMoedaLicenca(vendaValorAnualLicenca / 12) }}/mês
              </div>
            </div>
          </div>

          <div class="apps-calculator-box mb-3">
            <div class="apps-calculator-item">
              <span>Vai cobrar (anual)</span>
              <strong>{{ formatarMoedaLicenca(totalVendaAnualApps) }}</strong>
            </div>
            <div class="apps-calculator-item destaque">
              <span>Vai cobrar (mensal)</span>
              <strong>{{ formatarMoedaLicenca(totalVendaMensalApps) }}</strong>
            </div>
            <div class="apps-calculator-item apps-calculator-item-breakdown">
              <span>Custo anual (Licença+Modulos/Plugins)</span>
              <strong>{{ formatarMoedaLicenca(custoAnualTotalApps) }}</strong>
              <ul v-if="custoAnualDetalhamento.length" class="apps-calculator-breakdown">
                <li v-for="item in custoAnualDetalhamento" :key="item.label">
                  <span>{{ item.label }}</span>
                  <span>{{ formatarMoedaLicenca(item.valor) }}</span>
                </li>
              </ul>
            </div>
            <div class="apps-calculator-item" :class="margemAnualApps >= 0 ? 'margem-positiva' : 'margem-negativa'">
              <span>Margem estimada</span>
              <strong>{{ formatarMoedaLicenca(margemAnualApps) }}/ano</strong>
              <small>{{ formatarMoedaLicenca(margemMensalApps) }}/mês</small>
            </div>
          </div>

          <div v-if="!featuresClienteFiltradas.length" class="text-center py-5 text-muted">
            Nenhum módulo/plugin encontrado.
          </div>
          <div v-else class="table-responsive apps-feature-table-wrapper">
            <table class="table table-sm apps-feature-table">
              <thead>
                <tr>
                  <th style="width: 46px"></th>
                  <th>Módulo / Plugin</th>
                  <th style="width: 90px">Qtd.</th>
                  <th style="width: 130px">Custo anual</th>
                  <th style="width: 160px">Valor anual a cobrar</th>
                  <th style="width: 110px">Valor mensal</th>
                  <th style="width: 130px">Consumo saldo</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="feature in featuresClienteFiltradas"
                  :key="feature.code"
                  :class="{ 'apps-feature-row-ativo': feature.active, 'apps-feature-row-em-breve': isComingSoon(feature) }"
                >
                  <td :title="isComingSoon(feature) ? 'Ainda não disponível para liberação' : ''">
                    <b-form-checkbox
                      :checked="feature.active"
                      switch
                      :disabled="isComingSoon(feature)"
                      @change="onToggleFeature(feature, $event)"
                    />
                  </td>
                  <td>
                    <div class="d-flex align-items-center flex-wrap mb-1">
                      <strong class="mr-2">{{ feature.name }}</strong>
                      <span class="label label-inline label-sm mr-2" :class="feature.type === 'plugin' ? 'label-light-primary' : 'label-light-success'">
                        {{ feature.type === 'plugin' ? 'Plugin' : 'Módulo' }}
                      </span>
                      <span v-if="feature.originalActive" class="label label-inline label-sm label-light-primary mr-2">Ativo</span>
                      <span v-if="isComingSoon(feature)" class="label label-inline label-sm label-warning em-breve-badge">Em breve</span>
                    </div>
                    <div class="text-muted small">{{ feature.description || 'Sem descrição cadastrada.' }}</div>
                    <div v-if="isComingSoon(feature)" class="text-muted small font-weight-bold">
                      Ainda não disponível para liberação.
                    </div>
                    <div v-else-if="feature.originalActive" class="text-muted small">
                      {{ textoStatusFeature(feature) }}
                    </div>
                  </td>
                  <td>
                    <b-form-input
                      v-if="feature.billing_mode === 'per_quantity'"
                      v-model.number="feature.quantity"
                      type="number"
                      min="1"
                      size="sm"
                      style="width: 80px"
                      :disabled="!feature.active || isComingSoon(feature)"
                    />
                    <span v-else class="text-muted">—</span>
                  </td>
                  <td>
                    {{ formatarMoedaLicenca(custoAnualFeature(feature)) }}
                    <div v-if="feature.billing_mode === 'per_quantity'" class="text-muted small">
                      {{ formatarMoedaLicenca(feature.yearly_price) }}/{{ feature.quantity_label }}
                    </div>
                  </td>
                  <td>
                    <b-input-group prepend="R$" size="sm">
                      <b-form-input
                        v-model.number="feature.venda_valor_anual"
                        type="number"
                        min="0"
                        step="0.01"
                        :disabled="!feature.active || isComingSoon(feature)"
                      />
                    </b-input-group>
                  </td>
                  <td>
                    <strong>{{ formatarMoedaLicenca(valorMensalVendaFeature(feature)) }}</strong>
                  </td>
                  <td>
                    <strong>{{ formatarMoedaLicenca(totalConsumoFeature(feature)) }}</strong>
                    <div class="text-muted small">{{ textoConsumoFeature(feature) }}</div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        </div>

        <div class="apps-modal-footer">
          <div>
            <div class="font-weight-bold">Saldo disponível: {{ formatarMoedaLicenca(saldoApps.disponivel) }}</div>
            <div class="text-muted">Consumo desta liberação: {{ formatarMoedaLicenca(consumoTotalApps) }}</div>
            <div class="text-muted">Saldo após liberação: {{ formatarMoedaLicenca(saldoAposLiberacao) }}</div>
            <div v-if="consumoTotalApps > saldoApps.disponivel" class="text-danger font-weight-bold mt-1">
              Saldo insuficiente para liberar estes módulos/plugins.
            </div>
          </div>
          <div>
            <b-button variant="secondary" class="mr-2" @click="$bvModal.hide('modal-apps-cliente-revenda')">
              Cancelar
            </b-button>
            <b-button
              variant="primary"
              :disabled="salvandoFeaturesCliente || consumoTotalApps > saldoApps.disponivel"
              @click="salvarLiberacaoAppsCliente"
            >
              <b-spinner small class="mr-2" v-if="salvandoFeaturesCliente" />
              {{ salvandoFeaturesCliente ? 'Salvando...' : 'Salvar' }}
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Block from "vue-material-design-icons/ArchiveLock.vue";
import SendEmail from "vue-material-design-icons/MessageArrowRight.vue";
import TableApp from "@/components/Table/Table2";
import Contract from "vue-material-design-icons/EyeCheck.vue";
import Settings from "vue-material-design-icons/Console.vue";
import { SistemaMixin } from "@/modules/Application";
import FilterFields from "@/components/FilterFields";
import ListaCliente from "vue-material-design-icons/Lan.vue";
import InserirLicenca from "vue-material-design-icons/AlphaI.vue";
import Analytics from "vue-material-design-icons/GoogleAnalytics";
import AppsIcon from "vue-material-design-icons/Apps.vue";
import Download from "vue-material-design-icons/Download.vue";

export default {
  name: "app-clientes-revenda",
  mixins: [SistemaMixin],
  components: {
    Block,
    TableApp,
    SendEmail,
    Contract,
    FilterFields,
    Settings,
    ListaCliente,
    InserirLicenca,
    Analytics,
    AppsIcon,
    Download,
  },
  data() {
    return {
      fields: [
        {
          label: "Nome",
          field: "nome",
          type: "text",
          slot: true,
          sortable: true,
          width: "15%",
        },
        {
          label: "CPF/CNPJ",
          field: "cnpj",
          type: "text",
          slot: true,
          sortable: false,
          width: "8%",
        },
        {
          label: "Cidade",
          field: "cliente_cidade",
          type: "text",
          slot: true,
          sortable: false,
          width: "10%",
        },
        {
          label: "Licença",
          field: "data_validade",
          type: "text",
          slot: true,
          sortable: false,
          width: "22%",
          dateInputFormat: "DD/MM/YYYY",
          dateOutputFormat: "YYYY-MM-DD",
        },
        {
          label: "",
          field: "actions",
          sortable: false,
          slot: true,
          width: "15%",
          filterOptions: {
            enabled: false,
          },
        },
      ],
      licencas: null,
      nivelPartnerDefault: {
        nivel: 1,
        selo: null,
      },
      totalClientesRevenda: null,
      empresaUsoSelecionada: null,
      usoEmpresa: null,
      loadingUso: false,
      loadingSaldoApps: false,
      erroSaldoApps: null,
      saldoApps: {
        disponivel: 0,
        usado: 0,
        creditado: 0,
      },
      extratoSaldoApps: [],
      clientesTabela: [],
      totalClientesTabela: 0,
      clientesFree: [],
      loadingClientesFree: false,
      baixandoPdvOffline: false,
      clienteAppsSelecionado: null,
      vendaValorAnualLicenca: 0,
      licencaPrecificacaoPersonalizada: false,
      featuresCliente: [],
      loadingFeaturesCliente: false,
      salvandoFeaturesCliente: false,
      buscaFeatures: "",
      filtroRapidoFeatures: "all",
      filtrosRapidosFeatures: [
        { value: "all", text: "Todos" },
        { value: "module", text: "Módulos" },
        { value: "plugin", text: "Plugins" },
        { value: "active", text: "Ativos" },
        { value: "inactive", text: "Inativos" },
        { value: "per_quantity", text: "Por quantidade" },
        { value: "coming_soon", text: "Em breve" },
      ],
      periodosApps: [{ value: 12, text: "12 meses" }],
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    flagBoolean(valor, valorPadrao = true) {
      if (valor === null || valor === undefined || valor === "") return valorPadrao;
      if (typeof valor === "boolean") return valor;
      if (typeof valor === "number") return valor === 1;

      const normalizado = String(valor).toLowerCase().trim();
      return ["1", "true", "sim", "yes", "ativo", "available"].includes(normalizado);
    },
    async carregarSaldoApps() {
      this.loadingSaldoApps = true;
      this.erroSaldoApps = null;

      try {
        const response = await this.$http.get("/revenda/app-wallet");
        const payload = response?.data?.data ?? response?.data;
        const data = payload && typeof payload === "object" ? payload : {};
        const walletPayload = data.wallet ?? data;
        const wallet =
          walletPayload && typeof walletPayload === "object" ? walletPayload : {};

        this.saldoApps = {
          disponivel: this.valorNumericoLicenca(
            wallet.saldo_disponivel ??
              wallet.available_balance ??
              wallet.disponivel ??
              0
          ),
          usado: this.valorNumericoLicenca(
            wallet.saldo_usado ?? wallet.used_balance ?? wallet.usado ?? 0
          ),
          creditado: this.valorNumericoLicenca(
            wallet.saldo_total_creditado ??
              wallet.total_credited ??
              wallet.total_creditado ??
              wallet.creditado ??
              0
          ),
        };
        this.extratoSaldoApps = Array.isArray(data.movements)
          ? data.movements
          : Array.isArray(data.extrato)
          ? data.extrato
          : Array.isArray(data.transactions)
          ? data.transactions
          : Array.isArray(data.movimentacoes)
          ? data.movimentacoes
          : [];
      } catch (e) {
        this.erroSaldoApps =
          "Não foi possível carregar o saldo de Apps da revenda.";
      } finally {
        this.loadingSaldoApps = false;
      }
    },
    normalizarTagsFeature(tags) {
      if (!tags) return [];
      if (Array.isArray(tags)) return tags.filter(Boolean).map((item) => String(item));

      return String(tags)
        .split(",")
        .map((item) => item.trim())
        .filter(Boolean);
    },
    normalizarFeatureCliente(feature) {
      const cadastro = feature.feature || {};
      const billingMode = feature.billing_mode || cadastro.billing_mode || "flat";
      const status = String(feature.status || cadastro.status || "").toLowerCase();
      const available = this.flagBoolean(
        feature.available ??
          feature.disponivel ??
          cadastro.available ??
          cadastro.disponivel,
        true
      );
      const comingSoon =
        ["coming_soon", "comingsoon", "em_breve", "soon", "unavailable", "indisponivel"].includes(status) ||
        !available;
      const type = String(
        feature.type || feature.tipo || cadastro.type || cadastro.tipo || "module"
      ).toLowerCase();
      const minQuantity = Math.max(
        1,
        Number(
          feature.min_quantity ||
            feature.minimo_quantidade ||
            cadastro.min_quantity ||
            cadastro.minimo_quantidade ||
            1
        )
      );
      const atual =
        billingMode === "per_quantity"
          ? Math.max(minQuantity, Number(feature.quantity || feature.quantidade || 1))
          : 1;
      const active = comingSoon ? false : this.appLicencaAtivo(feature);
      const yearlyPrice = this.primeiroValorNumericoLicenca(
        feature.yearly_price,
        feature.valor_anual,
        feature.annual_price,
        cadastro.yearly_price,
        cadastro.valor_anual,
        cadastro.annual_price
      );
      const custoAnualBase = billingMode === "per_quantity" ? yearlyPrice * atual : yearlyPrice;
      const vendaValorAnualInicial =
        this.primeiroValorNumericoLicenca(
          feature.venda_valor_anual,
          feature.valor_venda_anual,
          feature.selling_price_annual,
          cadastro.venda_valor_anual
        ) || custoAnualBase;

      return {
        code: feature.code || cadastro.code,
        name:
          feature.name ||
          feature.nome ||
          cadastro.name ||
          cadastro.nome ||
          feature.code ||
          cadastro.code,
        description:
          feature.description ||
          feature.descricao ||
          cadastro.description ||
          cadastro.descricao ||
          "",
        type: type === "plugin" ? "plugin" : "module",
        billing_mode: billingMode,
        status,
        available,
        comingSoon,
        monthly_price: this.valorNumericoLicenca(
          feature.monthly_price ??
            feature.valor_mensal ??
            cadastro.monthly_price ??
            cadastro.valor_mensal ??
            0
        ),
        yearly_price: yearlyPrice,
        venda_valor_anual: vendaValorAnualInicial,
        personalizado: false,
        quantity_label:
          feature.quantity_label ||
          feature.rotulo_quantidade ||
          cadastro.quantity_label ||
          cadastro.rotulo_quantidade ||
          (type === "plugin" ? "item" : "unidade"),
        tags: this.normalizarTagsFeature(
          feature.tags || feature.etiquetas || cadastro.tags || cadastro.etiquetas || []
        ),
        active,
        originalActive: comingSoon ? false : active,
        quantity: atual,
        originalQuantity: comingSoon ? Math.max(1, minQuantity) : atual,
        min_quantity: minQuantity,
        months: 12,
        source: feature.source || feature.origem || "manual",
        valid_until:
          feature.valid_until || feature.expires_at || feature.data_validade || null,
      };
    },
    isComingSoon(feature) {
      if (!feature) return false;

      const status = String(feature.status || "").toLowerCase();
      return (
        feature.comingSoon === true ||
        feature.available === false ||
        status === "coming_soon" ||
        status === "unavailable"
      );
    },
    featureEstaEmBreve(feature) {
      return this.isComingSoon(feature);
    },
    onToggleFeature(feature, valor) {
      if (!feature) return;

      if (this.isComingSoon(feature)) {
        feature.active = false;
        this.$toast.warning(
          "Este módulo/plugin ainda não está disponível para liberação."
        );
        return;
      }

      feature.active = Boolean(valor);
    },
    async abrirModalAppsCliente(cliente) {
      this.clienteAppsSelecionado = cliente;
      this.featuresCliente = [];
      this.buscaFeatures = "";
      this.filtroRapidoFeatures = "all";
      this.vendaValorAnualLicenca = this.valorAnualPlanoLicenca(cliente);
      this.licencaPrecificacaoPersonalizada = false;
      this.loadingFeaturesCliente = true;
      this.$bvModal.show("modal-apps-cliente-revenda");

      try {
        let response;
        try {
          response = await this.$http.get(
            `/revenda/clientes/${cliente.id_empresa}/features`
          );
        } catch (errorApi) {
          response = await this.$http.get(
            `/revenda/clientes/${cliente.id_empresa}/features`
          );
        }
        const data = response?.data?.data ?? response?.data ?? {};
        const features = Array.isArray(data) ? data : data.features || data.items || [];
        const precificacao = Array.isArray(data.precificacao) ? data.precificacao : [];
        const precificacaoLicenca = precificacao.find((item) => item.tipo === "licenca");
        const precificacaoFeaturesPorCodigo = precificacao
          .filter((item) => item.tipo === "feature" && item.codigo)
          .reduce((mapa, item) => {
            mapa[item.codigo] = item;
            return mapa;
          }, {});

        if (precificacaoLicenca && precificacaoLicenca.valor_venda_anual != null) {
          this.vendaValorAnualLicenca = this.valorNumericoLicenca(precificacaoLicenca.valor_venda_anual);
        }
        this.licencaPrecificacaoPersonalizada = Boolean(precificacaoLicenca?.personalizado);

        this.featuresCliente = features
          .map((feature) => {
            const normalizado = this.normalizarFeatureCliente(feature);
            const precificacaoItem = precificacaoFeaturesPorCodigo[normalizado.code];

            if (precificacaoItem && precificacaoItem.valor_venda_anual != null) {
              normalizado.venda_valor_anual = this.valorNumericoLicenca(precificacaoItem.valor_venda_anual);
            }
            normalizado.personalizado = Boolean(precificacaoItem?.personalizado);

            return normalizado;
          })
          .filter((feature) => feature.code);
      } catch (e) {
        this.$toast.error("Erro ao carregar módulos/plugins do cliente.");
        this.$bvModal.hide("modal-apps-cliente-revenda");
      } finally {
        this.loadingFeaturesCliente = false;
      }
    },
    totalConsumoFeature(feature) {
      if (this.isComingSoon(feature)) return 0;

      const valorAnual = this.valorNumericoLicenca(feature.yearly_price);
      const quantidadeAtual =
        feature.billing_mode === "per_quantity"
          ? Math.max(1, Number(feature.quantity || 1))
          : 1;
      const quantidadeOriginal =
        feature.billing_mode === "per_quantity"
          ? Math.max(1, Number(feature.originalQuantity || 1))
          : 1;

      if (!feature.active) return 0;

      if (!feature.originalActive) {
        return feature.billing_mode === "per_quantity"
          ? valorAnual * quantidadeAtual
          : valorAnual;
      }

      if (feature.billing_mode === "per_quantity") {
        const adicional = Math.max(0, quantidadeAtual - quantidadeOriginal);
        return valorAnual * adicional;
      }

      return 0;
    },
    custoAnualFeature(feature) {
      if (this.isComingSoon(feature)) return 0;

      const valorAnual = this.valorNumericoLicenca(feature.yearly_price);
      const quantidade =
        feature.billing_mode === "per_quantity"
          ? Math.max(1, Number(feature.quantity || 1))
          : 1;

      return valorAnual * quantidade;
    },
    valorMensalVendaFeature(feature) {
      if (!feature.active || this.isComingSoon(feature)) return 0;

      return this.valorNumericoLicenca(feature.venda_valor_anual) / 12;
    },
    quantidadeAtualFeature(feature) {
      return Math.max(1, Number(feature.originalQuantity || 1));
    },
    quantidadeSelecionadaFeature(feature) {
      return Math.max(1, Number(feature.quantity || 1));
    },
    textoPrecoAnualFeature(feature) {
      const preco = this.formatarMoedaLicenca(feature.yearly_price);

      if (feature.billing_mode === "per_quantity") {
        return `${preco}/ano por ${feature.quantity_label}`;
      }

      return `${preco}/ano`;
    },
    textoConsumoFeature(feature) {
      const consumo = this.totalConsumoFeature(feature);
      if (!feature.active || consumo <= 0) return "Sem consumo adicional";
      const preco = this.formatarMoedaLicenca(feature.yearly_price);

      if (!feature.originalActive) {
        if (feature.billing_mode === "per_quantity") {
          return `${this.quantidadeSelecionadaFeature(feature)} x ${preco}/ano = ${this.formatarMoedaLicenca(consumo)}`;
        }

        return `${preco}/ano = ${this.formatarMoedaLicenca(consumo)}`;
      }

      const adicional = Math.max(
        0,
        Number(feature.quantity || 1) - Number(feature.originalQuantity || 1)
      );

      return `Consumo adicional: ${adicional} x ${preco}/ano = ${this.formatarMoedaLicenca(consumo)}`;
    },
    textoStatusFeature(feature) {
      if (this.isComingSoon(feature)) {
        return "Este módulo/plugin ainda não está disponível para liberação.";
      }

      if (!feature.originalActive) return "";
      const validade = feature.valid_until ? this.formatDate(feature.valid_until) : "sem data";
      const origem = this.textoOrigemFeatureCliente(feature.source);

      return `Ativo até ${validade} · Origem: ${origem}`;
    },
    textoOrigemFeatureCliente(source) {
      const mapa = {
        revenda: "Revenda",
        marketplace: "Marketplace",
        renewal: "Renovação",
        manual: "Manual",
        legacy: "Legado",
      };

      return mapa[source] || source || "Não informada";
    },
    formatarDataExtratoApps(data) {
      if (!data) return "--";
      return new Date(data).toLocaleString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    tipoMovimentoExtratoApps(movimento) {
      const tipo = String(
        movimento.movement_type || movimento.type || movimento.tipo || ""
      ).toLowerCase();
      return ["credit", "credito", "crédito"].includes(tipo) ? "Crédito" : "Débito";
    },
    classeValorExtratoApps(movimento) {
      const tipo = String(
        movimento.movement_type || movimento.type || movimento.tipo || ""
      ).toLowerCase();
      return ["credit", "credito", "crédito"].includes(tipo)
        ? "apps-wallet-value-credit"
        : "apps-wallet-value-debit";
    },
    sinalValorExtratoApps(movimento) {
      const tipo = String(
        movimento.movement_type || movimento.type || movimento.tipo || ""
      ).toLowerCase();
      return ["credit", "credito", "crédito"].includes(tipo) ? "+" : "-";
    },
    abrirModalExtratoApps() {
      this.$bvModal.show("modal-extrato-apps-revenda");
    },
    abrirModalClientesFree() {
      this.$bvModal.show("modal-clientes-free-revenda");
    },
    async salvarLiberacaoAppsCliente() {
      if (!this.clienteAppsSelecionado?.id_empresa) return;
      if (this.consumoTotalApps > this.saldoApps.disponivel) return;

      this.salvandoFeaturesCliente = true;
      try {
        const payload = {
          features: this.featuresCliente
            .filter((feature) => feature.code && !this.isComingSoon(feature))
            .map((feature) => ({
              code: feature.code,
              active: Boolean(feature.active),
              quantity:
                feature.billing_mode === "per_quantity"
                  ? Math.max(1, Number(feature.quantity || 1))
                  : 1,
              months: 12,
            })),
          precificacao: [
            {
              tipo: "licenca",
              codigo: null,
              valor_venda_anual: this.valorNumericoLicenca(this.vendaValorAnualLicenca),
            },
            ...this.featuresCliente
              .filter((feature) => feature.code && feature.active && !this.isComingSoon(feature))
              .map((feature) => ({
                tipo: "feature",
                codigo: feature.code,
                valor_venda_anual: this.valorNumericoLicenca(feature.venda_valor_anual),
                valor_custo_anual: this.custoAnualFeature(feature),
              })),
          ],
        };

        try {
          await this.$http.put(
            `/api/revenda/clientes/${this.clienteAppsSelecionado.id_empresa}/features`,
            payload
          );
        } catch (errorApi) {
          await this.$http.put(
            `/revenda/clientes/${this.clienteAppsSelecionado.id_empresa}/features`,
            payload
          );
        }

        this.$toast.success("Módulos/plugins atualizados com sucesso.");
        this.$bvModal.hide("modal-apps-cliente-revenda");
        this.$refs.clientes.refresh();
        await this.carregarSaldoApps();
      } catch (e) {
        this.$toast.error("Erro ao salvar liberação de módulos/plugins.");
      } finally {
        this.salvandoFeaturesCliente = false;
      }
    },
    onClientesLoaded(payload) {
      this.clientesTabela = Array.isArray(payload?.rows) ? payload.rows : [];
      this.totalClientesTabela = Number(payload?.total || 0);
    },
    async verUsoEmpresa(data) {
      this.empresaUsoSelecionada = data;
      this.usoEmpresa = null;
      this.loadingUso = true;
      this.$bvModal.show('modal-uso-empresa-clientes');
      try {
        const result = await this.$http.post('/empresa/uso-empresa', {
          id_empresa: data.id_empresa,
        });
        this.usoEmpresa = result.data.data ?? result.data;
      } catch (e) {
        this.$toast.error('Erro ao carregar dados de uso.');
        this.$bvModal.hide('modal-uso-empresa-clientes');
      } finally {
        this.loadingUso = false;
      }
    },
    diasDesde(dataStr) {
      if (!dataStr) return null;
      const agora = new Date();
      const data = new Date(dataStr);
      const hoje = new Date(agora.getFullYear(), agora.getMonth(), agora.getDate());
      const dataLocal = new Date(data.getFullYear(), data.getMonth(), data.getDate());
      const dias = Math.floor((hoje - dataLocal) / (1000 * 60 * 60 * 24));
      if (dias === 0) return 'Hoje';
      if (dias === 1) return 'Ontem';
      return `${dias} dias atrás`;
    },
    formatUsoDt(dataStr) {
      if (!dataStr) return '';
      return new Date(dataStr).toLocaleString('pt-BR', {
        day: '2-digit', month: '2-digit', year: 'numeric',
        hour: '2-digit', minute: '2-digit',
      });
    },
    resumoLicenca(row) {
      const empresa = row?.empresa || {};
      const resumo = row?.licenca_resumo || empresa.licenca_resumo || {};
      const plano = resumo.plano || {};
      const apps = resumo.apps || {};
      const totais = resumo.totais || {};
      const itensApps = this.itensAppsLicenca(row, apps);
      const valorPlanoResumo = this.valorNumericoLicenca(plano.valor_anual);
      const valorPlanoBase = this.valorNumericoLicenca(
        plano.base_valor_anual ??
          resumo.plano_valor_anual ??
          row?.valor ??
          empresa.valor ??
          0
      );
      const totalAnualApps = this.valorNumericoLicenca(apps.anual_total ?? 0);
      const totalMensalApps = this.valorNumericoLicenca(apps.mensal_total ?? 0);
      const totalAnualResumo = this.valorNumericoLicenca(
        totais.total_anual_licenca
      );
      const resumoInconsistente =
        valorPlanoResumo > 0 &&
        totalAnualResumo > 0 &&
        Math.abs(valorPlanoResumo + totalAnualApps - totalAnualResumo) > 0.01;
      const valorPlanoAnual =
        resumoInconsistente && valorPlanoBase > 0
          ? valorPlanoBase
          : valorPlanoResumo || valorPlanoBase;
      const totalAnualCalculado = valorPlanoAnual + totalAnualApps;
      const totalAtivos =
        Number(apps.total_ativos || 0) ||
        itensApps.filter((item) => this.appLicencaAtivo(item)).length;

      return {
        plano: {
          nome:
            plano.nome ||
            row?.plano ||
            row?.nome_plano ||
            empresa.plano ||
            empresa.nome_plano ||
            this.obterNomePlanoLicenca(row?.id_plan || empresa.id_plan),
          valor_anual: valorPlanoAnual,
          data_validade:
            plano.data_validade ||
            row?.data_validade ||
            empresa.data_validade ||
            null,
        },
        apps: {
          total_ativos: totalAtivos,
          anual_total: totalAnualApps,
          mensal_total: totalMensalApps,
          itens: itensApps,
        },
        totais: {
          total_anual_licenca:
            totalAnualResumo > 0 &&
            Math.abs(totalAnualResumo - totalAnualCalculado) <= 0.01
              ? totalAnualResumo
              : totalAnualCalculado,
          total_mensal_recorrente: this.valorNumericoLicenca(
            totais.total_mensal_recorrente ?? totalMensalApps
          ),
        },
      };
    },
    itensAppsLicenca(row, apps) {
      const empresa = row?.empresa || {};
      const listas = [
        apps?.itens,
        row?.apps,
        row?.modulos,
        row?.plugins,
        row?.features,
        empresa.apps,
        empresa.modulos,
        empresa.plugins,
        empresa.features,
      ];
      const itens = listas.find((lista) => Array.isArray(lista));

      return itens || [];
    },
    appLicencaAtivo(item) {
      const valor = item?.active ?? item?.ativo ?? item?.enabled ?? item?.liberado;

      if (typeof valor === "boolean") return valor;
      if (typeof valor === "number") return valor === 1;
      if (typeof valor === "string") {
        return ["1", "true", "sim", "yes", "ativo"].includes(valor.toLowerCase());
      }

      return true;
    },
    valorNumericoLicenca(valor) {
      if (valor === null || valor === undefined || valor === "") return 0;
      if (typeof valor === "number") return Number.isFinite(valor) ? valor : 0;

      const normalizado = String(valor)
        .replace(/[^\d,.-]/g, "")
        .replace(/\.(?=\d{3}(,|$))/g, "")
        .replace(",", ".");
      const numero = Number(normalizado);

      return Number.isFinite(numero) ? numero : 0;
    },
    primeiroValorNumericoLicenca(...valores) {
      for (const valor of valores) {
        const numero = this.valorNumericoLicenca(valor);
        if (numero > 0) return numero;
      }

      return 0;
    },
    formatarMoedaLicenca(valor) {
      return `R$ ${this.numberToReal(this.valorNumericoLicenca(valor), 2)}`;
    },
    obterNomePlanoLicenca(idPlan) {
      const planos = {
        1: "Free",
        2: "Essencial Anual",
        3: "Essencial Mensal",
        4: "Standard Mensal",
        6: "Standard Anual",
        7: "Basic",
      };

      return planos[Number(idPlan)] || "Plano não informado";
    },
    nomePlanoLicenca(row) {
      return this.resumoLicenca(row).plano.nome || "Plano não informado";
    },
    siglaPlanoLicenca(row) {
      const empresa = row?.empresa || {};
      const siglasPorPlano = {
        1: "F",
        2: "EA",
        3: "EM",
        4: "SM",
        6: "SA",
        7: "B",
      };
      const siglaPorId = siglasPorPlano[Number(row?.id_plan || empresa.id_plan)];

      if (siglaPorId) return siglaPorId;

      const sigla = this.nomePlanoLicenca(row)
        .split(" ")
        .filter(Boolean)
        .slice(0, 2)
        .map((parte) => parte.charAt(0))
        .join("")
        .toUpperCase();

      return sigla || "--";
    },
    dataValidadeLicenca(row) {
      const data = this.resumoLicenca(row).plano.data_validade;
      return data ? this.formatDate(data) : "";
    },
    valorAnualPlanoLicenca(row) {
      return this.resumoLicenca(row).plano.valor_anual;
    },
    totalAppsAtivosLicenca(row) {
      return this.resumoLicenca(row).apps.total_ativos;
    },
    totalAnualAppsLicenca(row) {
      return this.resumoLicenca(row).apps.anual_total;
    },
    totalMensalAppsLicenca(row) {
      return this.resumoLicenca(row).apps.mensal_total;
    },
    totalAnualLicenca(row) {
      return this.resumoLicenca(row).totais.total_anual_licenca;
    },
    totalMensalRecorrenteLicenca(row) {
      return this.resumoLicenca(row).totais.total_mensal_recorrente;
    },
    tooltipAppsLicenca(row) {
      const itens = this.resumoLicenca(row).apps.itens.filter((item) =>
        this.appLicencaAtivo(item)
      );

      if (!itens.length) return "Módulos/plugins ativos";

      return itens
        .map((item) => this.textoItemAppLicenca(item))
        .filter(Boolean)
        .map((texto) => this.escapeHtmlLicenca(texto))
        .join("<br>");
    },
    textoItemAppLicenca(item) {
      const nome =
        item.nome ||
        item.name ||
        item.titulo ||
        item.title ||
        item.codigo ||
        item.code ||
        "Módulo/plugin";
      const valorAnual = this.primeiroValorNumericoLicenca(
        item.valor_anual,
        item.anual_total,
        item.total_anual,
        item.annual_price
      );
      const valorMensal = this.primeiroValorNumericoLicenca(
        item.valor_mensal,
        item.mensal_total,
        item.total_mensal,
        item.monthly_price
      );
      const valores = [];

      if (valorAnual > 0) {
        valores.push(`${this.formatarMoedaLicenca(valorAnual)}/ano`);
      }

      if (valorMensal > 0) {
        valores.push(`${this.formatarMoedaLicenca(valorMensal)}/mês`);
      }

      return valores.length ? `${nome} - ${valores.join(" + ")}` : nome;
    },
    escapeHtmlLicenca(texto) {
      return String(texto)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
    },
    setarLicencas(data) {

      if (this.licencas <= 0) {
        this.$toast.warning(
          "Verifique suas licenças!"
        );
        return;
      }

      this.$swal
        .fire({
          title: "Deseja setar licenças para essa revenda?",
          text: "Informe o número de licenças desejada!",
          icon: "info",
          html: `
      <input type="text" id="total" class="swal2-input" placeholder="Número">`,
          confirmButtonText: "Enviar",
          cancelButtonText: "Cancelar",
          focusConfirm: false,
          showCancelButton: true,
          preConfirm: async () => {
            const total = this.$swal.getPopup().querySelector("#total").value;

            if (!total) {
              this.$toast.warning("Informe o número de licenças");
            }

            if (total > this.licencas) {
              this.$toast.warning(
                "A quantidade de licenças informada é maior do que você possui."
              );
              return;
            }

            await this.$http
              .post("/empresa/inserir-licenca", {
                total: total,
                id_empresa: data.id_empresa,
                revenda: true,
                id_revenda: this.idEmpresaRevenda
              })
              .then(() => {
                this.$toast.success("Licenças inseridas com sucesso!");
                this.$refs.clientes.refresh();
                this.getLicencas();
              })
              .catch(() => { });
          },
        })
        .then(() => { });
    },
    excluirCliente(data) {
      this.getRequestAdmin(() => {
        this.$swal
          .fire({
            icon: "warning",
            title:
              "Deseja  deletar o cliente " +
              data.cliente +
              "? Lembrando que o mesmo não irá mais acessar o sistema.",
            showCancelButton: true,
            confirmButtonText: `Sim`,
            cancelButtonText: `Não`,
            confirmButtonColor: "#f64e60",
          })
          .then(async (result) => {
            if (result.isConfirmed) {
              await this.$http.post("/empresa/excluir-cliente", {
                id_empresa: data.id_empresa,
              });
              this.$refs.clientes.refresh();
              this.$toast.success("E-mail enviado!");
            }
          });
      });
    },
    reenviarEmail(data) {
      this.$swal
        .fire({
          icon: "warning",
          title:
            "Deseja reenviar e-mail de primeiro acesso ao cliente " +
            data.cliente +
            "?",
          showCancelButton: true,
          confirmButtonText: `Sim`,
          cancelButtonText: `Não`,
          confirmButtonColor: "#f64e60",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            await this.$http.post("/empresa/enviar-email", {
              id_empresa: data.id_empresa,
            });
            this.$refs.clientes.refresh();
            this.$toast.success("E-mail enviado!");
          }
        });
    },
    bloquearAcesso(data) {
      this.$swal
        .fire({
          icon: "warning",
          title: "Deseja bloquear acesso ao cliente " + data.cliente + "?",
          showCancelButton: true,
          confirmButtonText: `Sim`,
          cancelButtonText: `Não`,
          confirmButtonColor: "#f64e60",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            await this.$http.post("/empresa/bloquear-cliente", {
              id_empresa: data.id_empresa,
            });
            this.$refs.clientes.refresh();
            this.$toast.success("Acesso bloqueado!");
          }
        });
    },
    liberarAcesso(data) {
      this.$swal
        .fire({
          icon: "warning",
          title: "Deseja liberar acesso ao cliente " + data.cliente + "?",
          showCancelButton: true,
          confirmButtonText: `Sim`,
          cancelButtonText: `Não`,
          confirmButtonColor: "#f64e60",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            await this.$http.post("/empresa/liberar-cliente", {
              id_empresa: data.id_empresa,
            });
            this.$refs.clientes.refresh();
            this.$toast.success("Acesso liberado!");
          }
        });
    },
    async getLicencas() {
      const data = await this.$http.post("/empresa/total-licencas", {
        id_empresa: this.idEmpresaRevenda,
      });

      this.licencas = data.data.total;
      this.totalClientesRevenda = data.data.total_clientes;
    },
    labelDiasRestantesFree(clienteFree) {
      const dias = Number(clienteFree.dias_restantes);
      return dias < 0 ? "Expirado" : dias + " dia(s)";
    },
    async baixarPdvOffline() {
      if (!this.idEmpresaRevenda || this.baixandoPdvOffline) return;

      this.baixandoPdvOffline = true;
      try {
        const { data } = await this.$http.post("/empresa/pdv-offline-url", {
          id_revenda: this.idEmpresaRevenda,
        });
        const url = data?.url_pdv_off ?? data?.data?.url_pdv_off ?? null;

        if (!url) {
          this.$toast.warning("Ainda não há instalador do PDV Offline disponível.");
          return;
        }

        window.open(url, "_blank");
      } catch (error) {
        const msg =
          error.response && error.response.data && error.response.data.msg
            ? error.response.data.msg
            : "Não foi possível obter o instalador do PDV Offline.";
        this.$toast.error(msg);
      } finally {
        this.baixandoPdvOffline = false;
      }
    },
    async carregarClientesFree() {
      this.loadingClientesFree = true;
      try {
        const { data } = await this.$http.post("/empresa/clientes-free-parceiro", {});
        this.clientesFree = (data && data.clientes) || [];
      } catch (error) {
        const msg =
          error.response && error.response.data && error.response.data.msg
            ? error.response.data.msg
            : "Não foi possível carregar os clientes free.";
        this.$toast.error(msg);
      } finally {
        this.loadingClientesFree = false;
      }
    },
    ativarClienteFree(clienteFree) {
      this.$swal
        .fire({
          icon: "info",
          title: "Ativar cliente " + clienteFree.cliente + "?",
          html: `
            <p style="margin-bottom:8px;">Essa ação irá consumir 1 licença da revenda.</p>
            <select id="id_plan" class="swal2-select">
              <option value="2" selected>Essencial Anual</option>
              <option value="3">Essencial Mensal</option>
              <option value="4">Standard Anual</option>
              <option value="5">Standard Mensal</option>
            </select>`,
          showCancelButton: true,
          confirmButtonText: "Ativar",
          cancelButtonText: "Cancelar",
          focusConfirm: false,
          preConfirm: () => {
            const select = this.$swal.getPopup().querySelector("#id_plan");
            return { id_plan: select ? Number(select.value) : 2 };
          },
        })
        .then(async (result) => {
          if (!result.isConfirmed) return;

          const idPlan = result.value && result.value.id_plan ? result.value.id_plan : 2;

          try {
            await this.$http.post("/empresa/ativar-cliente-free-parceiro", {
              id_empresa: clienteFree.id_empresa,
              id_plan: idPlan,
            });
            this.$toast.success("Cliente ativado com sucesso!");
            await Promise.all([this.carregarClientesFree(), this.getLicencas()]);
            this.$refs.clientes.refresh();
          } catch (error) {
            const msg =
              error.response && error.response.data && error.response.data.msg
                ? error.response.data.msg
                : "Não foi possível ativar o cliente.";
            this.$toast.error(msg);
          }
        });
    },
  },
  computed: {
    ...mapGetters([
      "layoutConfig",
      "itsblocked",
      "isRevenda",
      "currentUser",
      "idRevenda",
      "dadosRevenda",
      "empresa",
    ]),
    config() {
      return this.layoutConfig();
    },
    nivelPartner() {
      return (
        this.currentUser?.usuario_empresa?.empresa?.nivel_revenda ||
        this.currentUser?.empresa?.nivel_revenda ||
        this.currentUser?.empresa?.dados_revenda?.nivel_revenda ||
        this.currentUser?.nivel_revenda ||
        this.empresa?.nivel_revenda ||
        this.empresa?.dados_revenda?.nivel_revenda ||
        this.dadosRevenda?.nivel_revenda ||
        this.nivelPartnerDefault
      );
    },
    idEmpresaRevenda() {
      return (
        this.currentUser?.usuario_empresa?.empresa?.id_empresa ||
        this.currentUser?.empresa?.id_empresa ||
        this.currentUser?.usuario_empresa?.id_empresa ||
        this.currentUser?.id_empresa ||
        this.empresa?.id_empresa ||
        this.idRevenda
      );
    },
    mostrarModulosPlugins() {
      return Number(this.idRevenda) === 1;
    },
    temperaturaUso() {
      if (!this.usoEmpresa) return { tipo: 'frio', dias: null };
      const timestamps = [
        this.usoEmpresa.ultimo_login,
        this.usoEmpresa.ultima_nfe,
        this.usoEmpresa.ultima_atualizacao_pessoa,
        this.usoEmpresa.ultima_atualizacao_produto,
        this.usoEmpresa.ultimo_pedido,
        this.usoEmpresa.ultimo_orcamento,
        this.usoEmpresa.ultima_ordem_servico,
      ].filter(Boolean).map(d => new Date(d).getTime());
      if (!timestamps.length) return { tipo: 'frio', dias: null };
      const maisRecente = Math.max(...timestamps);
      const agora = new Date();
      const hoje = new Date(agora.getFullYear(), agora.getMonth(), agora.getDate());
      const dataRecente = new Date(maisRecente);
      const dataLocal = new Date(dataRecente.getFullYear(), dataRecente.getMonth(), dataRecente.getDate());
      const dias = Math.floor((hoje - dataLocal) / (1000 * 60 * 60 * 24));
      if (dias <= 7) return { tipo: 'quente', dias };
      if (dias <= 30) return { tipo: 'morno', dias };
      return { tipo: 'frio', dias };
    },
    temperaturaScore() {
      if (!this.temperaturaUso || this.temperaturaUso.dias === null) return 0;
      return Math.max(0, Math.round(100 - (this.temperaturaUso.dias / 90) * 100));
    },
    metricasUso() {
      if (!this.usoEmpresa) return [];
      const agora = new Date();
      const hoje = new Date(agora.getFullYear(), agora.getMonth(), agora.getDate());
      const calcDias = (d) => {
        if (!d) return null;
        const dt = new Date(d);
        const dataLocal = new Date(dt.getFullYear(), dt.getMonth(), dt.getDate());
        return Math.floor((hoje - dataLocal) / (1000 * 60 * 60 * 24));
      };
      return [
        { label: 'Último Login', icone: '👤', valor: this.usoEmpresa.ultimo_login, dias: calcDias(this.usoEmpresa.ultimo_login) },
        { label: 'Última NF-e Emitida', icone: '📄', valor: this.usoEmpresa.ultima_nfe, dias: calcDias(this.usoEmpresa.ultima_nfe) },
        { label: 'Últ. Atualiz. de Pessoa', icone: '👥', valor: this.usoEmpresa.ultima_atualizacao_pessoa, dias: calcDias(this.usoEmpresa.ultima_atualizacao_pessoa) },
        { label: 'Últ. Atualiz. de Produto', icone: '📦', valor: this.usoEmpresa.ultima_atualizacao_produto, dias: calcDias(this.usoEmpresa.ultima_atualizacao_produto) },
        { label: 'Último Pedido', icone: '🛒', valor: this.usoEmpresa.ultimo_pedido, dias: calcDias(this.usoEmpresa.ultimo_pedido) },
        { label: 'Último Orçamento', icone: '📋', valor: this.usoEmpresa.ultimo_orcamento, dias: calcDias(this.usoEmpresa.ultimo_orcamento) },
        { label: 'Última Ordem de Serviço', icone: '🔧', valor: this.usoEmpresa.ultima_ordem_servico, dias: calcDias(this.usoEmpresa.ultima_ordem_servico) },
      ];
    },
    saldoAppsZerado() {
      return !this.loadingSaldoApps && this.saldoApps.disponivel <= 0;
    },
    licencasDisponiveis() {
      return Math.max(0, Number(this.licencas || 0));
    },
    licencasUtilizadas() {
      const totalClientes = Number(this.totalClientesRevenda || 0);
      return Math.max(0, totalClientes - this.totalClientesFree);
    },
    totalLicencas() {
      return this.licencasDisponiveis + this.licencasUtilizadas;
    },
    percentualUsoLicencas() {
      if (this.totalLicencas <= 0) return 0;
      return Math.round((this.licencasUtilizadas / this.totalLicencas) * 100);
    },
    totalClientesResumo() {
      if (this.totalClientesTabela > 0) return this.totalClientesTabela;
      return Number(this.totalClientesRevenda || 0);
    },
    totalClientesFree() {
      return this.clientesFree.length;
    },
    clientesFreeResumoMini() {
      return [...this.clientesFree]
        .sort((a, b) => Number(a.dias_restantes) - Number(b.dias_restantes))
        .slice(0, 3);
    },
    clientesComAppsResumo() {
      return this.clientesTabela.filter(
        (row) => this.totalAppsAtivosLicenca(row) > 0
      ).length;
    },
    totalAnualLicencasResumo() {
      return this.clientesTabela.reduce(
        (acc, row) => acc + this.totalAnualLicenca(row),
        0
      );
    },
    mensalRecorrenteAppsResumo() {
      return this.clientesTabela.reduce(
        (acc, row) => acc + this.totalMensalRecorrenteLicenca(row),
        0
      );
    },
    documentoClienteAppsSelecionado() {
      const documento = this.clienteAppsSelecionado?.cnpj;
      if (!documento) return "Não informado";

      try {
        return this.formatCpfCnpj(documento);
      } catch (e) {
        return documento;
      }
    },
    featuresClienteFiltradas() {
      const termo = this.buscaFeatures
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .trim();

      return this.featuresCliente.filter((feature) => {
        if (this.filtroRapidoFeatures === "module" && feature.type !== "module") return false;
        if (this.filtroRapidoFeatures === "plugin" && feature.type !== "plugin") return false;
        if (this.filtroRapidoFeatures === "active" && !feature.active) return false;
        if (this.filtroRapidoFeatures === "inactive" && feature.active) return false;
        if (this.filtroRapidoFeatures === "per_quantity" && feature.billing_mode !== "per_quantity") return false;
        if (this.filtroRapidoFeatures === "coming_soon" && !this.isComingSoon(feature)) return false;

        if (!termo) return true;

        const conteudo = [
          feature.name,
          feature.description,
          feature.type,
          feature.code,
          feature.status,
          feature.available === false ? "em breve" : "",
          ...(feature.tags || []),
        ]
          .filter(Boolean)
          .join(" ")
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "");

        return conteudo.includes(termo);
      });
    },
    consumoTotalApps() {
      return this.featuresCliente.reduce(
        (acc, feature) => acc + this.totalConsumoFeature(feature),
        0
      );
    },
    saldoAposLiberacao() {
      return Math.max(0, this.saldoApps.disponivel - this.consumoTotalApps);
    },
    custoAnualLicencaSelecionada() {
      return this.clienteAppsSelecionado
        ? this.valorAnualPlanoLicenca(this.clienteAppsSelecionado)
        : 0;
    },
    custoAnualTotalApps() {
      const custoApps = this.featuresCliente
        .filter((feature) => feature.active && !this.isComingSoon(feature))
        .reduce((acc, feature) => acc + this.custoAnualFeature(feature), 0);

      return custoApps + this.custoAnualLicencaSelecionada;
    },
    custoAnualDetalhamento() {
      const itens = [];

      if (this.custoAnualLicencaSelecionada > 0) {
        itens.push({
          label: 'Licença (' + this.nomePlanoLicenca(this.clienteAppsSelecionado) + ')',
          valor: this.custoAnualLicencaSelecionada,
        });
      }

      this.featuresCliente
        .filter((feature) => feature.active && !this.isComingSoon(feature) && this.custoAnualFeature(feature) > 0)
        .forEach((feature) => {
          itens.push({ label: feature.name, valor: this.custoAnualFeature(feature) });
        });

      return itens;
    },
    totalVendaAnualApps() {
      const totalApps = this.featuresCliente
        .filter((feature) => feature.active && !this.isComingSoon(feature))
        .reduce((acc, feature) => acc + this.valorNumericoLicenca(feature.venda_valor_anual), 0);

      return totalApps + this.valorNumericoLicenca(this.vendaValorAnualLicenca);
    },
    totalVendaMensalApps() {
      return this.totalVendaAnualApps / 12;
    },
    margemAnualApps() {
      return this.totalVendaAnualApps - this.custoAnualTotalApps;
    },
    margemMensalApps() {
      return this.margemAnualApps / 12;
    },
  },
  async mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }

    if (!this.isRevenda) {
      this.$router.push({ name: "dashboard" });
    }

    await Promise.all([this.getLicencas(), this.carregarSaldoApps(), this.carregarClientesFree()]);
  },
};
</script>

<style scoped>
.apps-wallet-row {
  display: flex;
  align-items: stretch;
  gap: 16px;
  flex-wrap: wrap;
}

.apps-wallet-row .apps-wallet-card {
  margin: 14px 0 16px;
}

.apps-wallet-card-flex {
  flex: 3 1 480px;
}

.apps-wallet-card-compact {
  flex: 1 1 220px;
  display: flex;
  flex-direction: column;
}

.clientes-free-mini-card {
  cursor: pointer;
  border-color: #ffcc80;
  background: #fff8f0;
  transition: box-shadow 0.15s ease, transform 0.15s ease;
}

.clientes-free-mini-card:hover,
.clientes-free-mini-card:focus {
  box-shadow: 0 2px 10px rgba(255, 153, 0, 0.25);
  transform: translateY(-1px);
  outline: none;
}

.apps-wallet-mini-count {
  display: flex;
  align-items: baseline;
  gap: 6px;
  margin-bottom: 6px;
}

.apps-wallet-mini-count strong {
  font-size: 32px;
  font-weight: 700;
  color: #181c32;
  line-height: 1;
}

.apps-wallet-mini-count span {
  color: #7e8299;
  font-size: 13px;
  font-weight: 600;
}

.clientes-free-mini-list {
  list-style: none;
  margin: 8px 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.clientes-free-mini-list li {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 8px;
  font-size: 12px;
}

.clientes-free-mini-nome {
  color: #181c32;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.clientes-free-mini-mais {
  margin-top: 6px;
  font-size: 11px;
}

.apps-wallet-card {
  margin: 14px 0 16px;
  background: #fff;
  border: 1px solid #e4e6ef;
  border-radius: 8px;
  padding: 16px;
}

.apps-wallet-card-header {
  margin-bottom: 10px;
}

.apps-wallet-kicker {
  display: block;
  color: #7e8299;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  margin-bottom: 4px;
}

.apps-wallet-title {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: #181c32;
}

.apps-wallet-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 10px;
}

.apps-wallet-item {
  border: 1px solid #e4e6ef;
  border-radius: 8px;
  padding: 12px;
  background: #fcfcfd;
}

.apps-wallet-item.destaque {
  border-color: #91b7ff;
  background: #eef4ff;
}

.apps-wallet-item.destaque-licencas {
  border-color: #7bdcb5;
  background: #effaf5;
}

.apps-wallet-item span {
  display: block;
  color: #7e8299;
  font-size: 11px;
  text-transform: uppercase;
  font-weight: 700;
}

.apps-wallet-item strong {
  display: block;
  color: #181c32;
  font-size: 18px;
  margin-top: 4px;
}

.apps-wallet-item small {
  display: block;
  margin-top: 4px;
  color: #7e8299;
  font-size: 12px;
}

.apps-wallet-actions {
  margin-top: 12px;
  display: flex;
  justify-content: flex-end;
}

.apps-wallet-note {
  margin-top: 8px;
  font-size: 12px;
}

.apps-wallet-table th {
  font-size: 11px;
  text-transform: uppercase;
  color: #7e8299;
}

.apps-wallet-table td {
  font-size: 12px;
  color: #3f4254;
  vertical-align: middle;
}

.apps-wallet-value {
  font-weight: 700;
}

.apps-wallet-value-credit {
  color: #1f8b4c;
}

.apps-wallet-value-debit {
  color: #d63343;
}

.apps-modal-shell {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
}

.apps-modal-scroll {
  flex: 1 1 auto;
  overflow-y: auto;
  min-height: 0;
  padding-right: 4px;
}

.apps-modal-header {
  border: 1px solid #e4e6ef;
  border-radius: 8px;
  background: #fcfcfd;
  padding: 12px;
}

.apps-modal-top-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  flex-wrap: wrap;
}

.apps-modal-top-row .apps-modal-header {
  flex: 1 1 260px;
  margin: 0;
}

.apps-toolbar-compact {
  flex: 0 1 280px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.apps-toolbar-search-compact {
  max-width: 260px;
}

.apps-toolbar-filters-compact {
  justify-content: flex-end;
}

.apps-toolbar-search {
  max-width: 520px;
}

.apps-toolbar-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.apps-filter-chip {
  border: 1px solid #d8dbe7;
  background: #fff;
  border-radius: 16px;
  font-size: 12px;
  line-height: 1;
  padding: 8px 12px;
  color: #5e6278;
}

.apps-filter-chip.ativo {
  border-color: #0d6efd;
  color: #0d6efd;
  background: #ecf4ff;
  font-weight: 600;
}

.em-breve-badge {
  background: #fff4de;
  color: #b86a00;
  border: 1px solid #ffd9a0;
}

.apps-license-pricing-box {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 10px;
  border: 1px solid #7bdcb5;
  background: #effaf5;
  border-radius: 8px;
  padding: 12px;
}

.apps-license-pricing-box strong {
  display: block;
  font-size: 15px;
  color: #181c32;
}

.apps-precificacao-sugestao {
  display: inline-block;
  margin-left: 6px;
  padding: 1px 6px;
  border-radius: 10px;
  background: #fff4de;
  color: #b86a00;
  border: 1px solid #ffd9a0;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  vertical-align: middle;
}

.apps-calculator-box {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 10px;
}

.apps-calculator-item {
  border: 1px solid #e4e6ef;
  border-radius: 8px;
  padding: 10px 12px;
  background: #fcfcfd;
}

.apps-calculator-item.destaque {
  border-color: #91b7ff;
  background: #eef4ff;
}

.apps-calculator-item span {
  display: block;
  color: #7e8299;
  font-size: 11px;
  text-transform: uppercase;
  font-weight: 700;
}

.apps-calculator-item strong {
  display: block;
  color: #181c32;
  font-size: 17px;
  margin-top: 4px;
}

.apps-calculator-item small {
  display: block;
  margin-top: 2px;
  color: #7e8299;
  font-size: 11px;
}

.apps-calculator-item.margem-positiva strong {
  color: #1f8b4c;
}

.apps-calculator-item.margem-negativa strong {
  color: #d63343;
}

.apps-calculator-item-breakdown {
  display: flex;
  flex-direction: column;
}

.apps-calculator-breakdown {
  list-style: none;
  margin: 6px 0 0;
  padding: 6px 0 0;
  border-top: 1px dashed #e4e6ef;
  max-height: 110px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.apps-calculator-breakdown li {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  font-size: 11px;
  font-weight: 400;
  color: #5e6278;
}

.apps-calculator-breakdown li span:first-child {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.apps-feature-table-wrapper {
  overflow: visible;
}

.apps-feature-table th {
  font-size: 11px;
  text-transform: uppercase;
  color: #7e8299;
  white-space: nowrap;
}

.apps-feature-table td {
  vertical-align: middle;
  font-size: 12px;
}

.apps-feature-row-ativo {
  background: #f6faff;
}

.apps-feature-row-em-breve {
  background: #fffaf1;
  opacity: 0.85;
}

.apps-modal-footer {
  flex-shrink: 0;
  background: #fff;
  border-top: 1px solid #e4e6ef;
  box-shadow: 0 -6px 14px rgba(24, 28, 50, 0.06);
  margin: 12px -16px 0;
  padding: 12px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}

.license-summary-cell {
  min-width: 190px;
  max-width: 240px;
  color: #3f4254;
  font-size: 12px;
  line-height: 1.35;
}

.license-plan-line {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 2px;
  color: #181c32;
}

.license-plan-line strong {
  font-size: 12px;
  line-height: 1.2;
}

.license-plan-badge {
  min-width: 26px;
  height: 20px;
  padding: 0 6px;
  border-radius: 4px;
  background: #e8fff3;
  color: #1bc5bd;
  font-size: 11px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.license-muted {
  color: #7e8299;
}

.license-lines {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid #eef0f6;
}

.license-row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 3px;
}

.license-row span:first-child {
  flex-shrink: 0;
}

.license-row strong,
.license-row span:last-child {
  text-align: right;
}

.license-apps-row {
  cursor: help;
}

.license-empty {
  color: #7e8299;
  font-weight: 600;
  margin-top: 4px;
}

.license-total-line {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid #eef0f6;
  color: #181c32;
}

.license-total-line strong {
  font-size: 13px;
}

.license-recurring-line {
  margin-top: 2px;
  color: #8950fc;
  font-weight: 700;
  text-align: right;
}

.license-status-line {
  margin-top: 6px;
}

.license-action-line {
  margin-top: 8px;
}

.license-apps-quick-btn {
  min-height: 24px;
  font-size: 11px;
  padding: 2px 8px;
}

.row-actions .btn.btn-icon {
  width: 24px;
  height: 24px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}

@media (max-width: 991px) {
  .apps-wallet-card,
  .apps-modal-footer {
    flex-direction: column;
    align-items: stretch;
  }

  .apps-wallet-grid {
    grid-template-columns: 1fr;
  }
}
</style>

<style>
.apps-modal-fullscreen-dialog {
  max-width: 96vw !important;
  width: 96vw;
  margin: 2vh auto;
}

.apps-modal-fullscreen-content {
  max-height: 96vh;
}

.apps-modal-fullscreen-content .modal-body {
  height: calc(96vh - 120px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
</style>
